<template>
    <AccordionHeader class="flex">
        <AccordionTrigger
            v-bind="delegatedProps"
            :class="cn('group flex flex-1 gap-2 items-center py-4 font-normal transition-all', props.class)">
            <slot />
            <slot name="icon">
                <Icon
                    name="chevron-down"
                    class="ml-auto shrink-0 transition-transform duration-200 group-data-[state=open]:rotate-180" />
            </slot>
        </AccordionTrigger>
    </AccordionHeader>
</template>
<script setup lang="ts">
//  [&[data-state=open]>span]:rotate-180
import { AccordionHeader, AccordionTrigger, type AccordionTriggerProps } from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<AccordionTriggerProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>
